module.exports = __webpack_public_path__ + "img/IMG-20210111-WA0011.a284804d.jpg";